import { FocusTrap } from 'focus-trap-react'
import { useCallback, useContext, useEffect, useState } from 'react'
import { Context } from 'src/Subscribe_'
import Recipient from './Recipient'
import { Book } from 'src/subscribe'

const Review = ({ startableBooks }: { startableBooks: Book[] }) => {
  const { dispatch, state } = useContext(Context)

  const [startOverModalVisible, setStartOverModalVisible] =
    useState<boolean>(false)

  const handleAddRecipientClick = useCallback(() => {
    dispatch({
      type: 'add recipient clicked',
    })
  }, [])

  const handlePaymentClick = useCallback(() => {
    dispatch({
      type: 'review payment clicked',
    })
  }, [state.values])

  const handleStartOverCancel = useCallback(() => {
    setStartOverModalVisible(false)
  }, [])

  const handleStartOverClick = useCallback(() => {
    setStartOverModalVisible(true)
  }, [])

  const handleStartOverConfirm = useCallback(() => {
    setStartOverModalVisible(false)
    dispatch({
      type: 'start over confirmed',
    })
  }, [])

  useEffect(() => {
    if (Object.values(state.values.recipients || {}).length === 0) {
      dispatch({
        type: 'all recipients removed',
      })
    }
  }, [state.values.recipients])

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setStartOverModalVisible(false)
      }
    }

    if (startOverModalVisible) {
      document.addEventListener('keydown', handleKeydown)
    } else {
      document.removeEventListener('keydown', handleKeydown)
    }
  }, [startOverModalVisible])

  return (
    <div className="page page5 show">
      <div className="heading">Recipients</div>
      <div>
        <div className="recipients">
          {Object.entries(state.values.recipients || {}).map(([id, r]) => (
            <Recipient startableBooks={startableBooks} key={id} recipient={r} />
          ))}
        </div>
        <div className="add-recipient">
          <button onClick={handleAddRecipientClick} type="button">
            +Add recipient
          </button>
        </div>
      </div>
      <div className="navigation">
        <button
          className="continue show"
          onClick={handlePaymentClick}
          type="button"
        >
          Payment
        </button>
        {state.serverErrors.nonce && (
          <div className="server-error-message">
            Server error: {state.serverErrors.nonce}
          </div>
        )}
        {state.serverErrors.startable_books && (
          <div className="server-error-message">
            Server error: {state.serverErrors.startable_books}
          </div>
        )}
        <button
          className="back show"
          onClick={handleStartOverClick}
          type="button"
        >
          Start over
        </button>
      </div>
      {startOverModalVisible && (
        <FocusTrap>
          <div className="overlay enabled active">
            <div className="block__content">
              <div>
                <div className="info">
                  <p>Start over?</p>
                  <p>All information will be cleared.</p>
                </div>
                <div className="actions">
                  <button onClick={handleStartOverConfirm} type="button">
                    Confirm
                  </button>
                  <button onClick={handleStartOverCancel} type="button">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      )}
    </div>
  )
}

export default Review
